// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module__header___zYK9W","collumn1":"style-module__collumn1___nMWoD","collumn2":"style-module__collumn2___D1py9","content":"style-module__content___0xF3E"};